import React from "react";
import styles from "./Checkbox.module.scss";

const Checkbox = ({ onCheck, checked }) => {
  const handleChange = (e) => {
    // Stop propagation to prevent parent click handlers
    e.stopPropagation();
    if (onCheck) {
      onCheck(e);
    }
  };

  return (
    <input
      type={"checkbox"}
      className={styles.checkbox}
      onChange={handleChange}
      onClick={(e) => {
        // Stop propagation on click as well
        e.stopPropagation();
      }}
      checked={checked}
    />
  );
};

export default Checkbox;
